import React, { useState } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { Header as OrderHeader } from 'components/order/Header';
import {
    Vendor,
    OrderOption,
} from 'model/index';
import { Messenger } from 'components/messenger/Messenger';
import { Loading } from 'components/loading/Loading';
import { Outlet, useMatchRoute, useNavigate } from '@tanstack/react-router';
import clsx from 'clsx';
import { Layout } from 'antd';
import { VendorSlider } from 'components/order/VendorSlider';
import {
    getSettingsAsync,
    selectIsLoaded,
    selectVendors,
    selectOrderOptions,
    selectOrderHasEnded,
} from 'store/order';
import AppStateProvider from './AppStateProvider';
import { Navigation } from './Navigation';
import { MenuIcon } from './MenuIcon';

import {
    getAnnouncementsAsync
} from 'store/user';


type OrderLayoutProps = {
    children?: React.ReactNode;
};

export const OrderLayout = (props: OrderLayoutProps) => {

    const dispatch = useAppDispatch();
    const isLoaded: boolean = useAppSelector(selectIsLoaded);
    const vendors: Vendor[] = useAppSelector(selectVendors);
    const matchRoute = useMatchRoute();
    const orderOptions: OrderOption = useAppSelector(selectOrderOptions);
    const orderHasEnded: boolean = useAppSelector(selectOrderHasEnded);
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoaded) {

            dispatch(getSettingsAsync());

            dispatch(getAnnouncementsAsync(false));
        }
    }, [isLoaded]);

    React.useEffect(() => {
        if (isLoaded && orderHasEnded) {
            navigate({ to: '/order-summary' });
        }
    }, [isLoaded, orderHasEnded]);

    const vendorsWithLogos = vendors.filter((vendor: Vendor) => {
        return vendor.logo != null && vendor.primeVendor && vendor.logo.length > 0;
    });

    const isOrderPage = matchRoute({ to: '/order' });

    const headerHeight: string = (isOrderPage && vendorsWithLogos.length > 0) ? "111px" : "50px";

    const messengerCss = clsx({
        "hidden": !orderOptions.messageEnabled,
    });

    if (isLoaded) {
        return (
            <AppStateProvider>
                <MenuIcon />
                <div className="order-window">
                    <div className="order-header" style={{ height: headerHeight, minHeight: headerHeight }} >
                        <OrderHeader />
                        {isOrderPage && <VendorSlider />}
                    </div>
                    <Layout style={{ flex: 1, overflow: 'hidden' }}>
                        {props.children || <Outlet />}
                    </Layout>
                </div>
                <div className={messengerCss}>
                    <Messenger />
                </div>
                <Navigation />
            </AppStateProvider>
        )
    } else {
        return (
            <Loading />
        );
    }
};

